import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import theme from 'shared/styles/theme';

interface ConfirmPaymentProps {
  repayAmount: string;
  accountName: string;
}

const ConfirmPayment = ({ repayAmount, accountName }: ConfirmPaymentProps) => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'advanceConfirmPaymentStrings',
  });

  return (
    <View style={styles.innerContainer}>
      <ListItem
        primaryCopy={'$' + repayAmount}
        lineFormat={ListItemLineFormat.LABEL}
        secondaryCopy={translatedText('paymentAmount')}
        showsChevron={false}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={accountName}
        secondaryCopy={translatedText('repayFrom')}
        lineFormat={ListItemLineFormat.LABEL}
        showsChevron={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  hairLine: {
    marginHorizontal: theme.spacing.m,
  },
  innerContainer: {
    flex: 1,
    width: '100%',
  },
});

export default ConfirmPayment;
